export const CASH_FORECAST_QUERY_KEY = ['cash-report-forecast'] as const

export type ForecastCacheEnvelope = {
  data?: {
    version?: unknown
    audit_count?: number
    actions?: unknown
    [key: string]: unknown
  }
  error?: unknown
  message?: string
  [key: string]: unknown
}

/** This-week close dollars from a mutation version. Null if week-0 is missing. */
export function week0CloseAmount(version: unknown): number | null {
  const payload = version && typeof version === 'object' ? (version as { payload?: { weeks?: Array<{ close?: { amount?: number }; close_cents?: number }> } }).payload : null
  const week = payload?.weeks?.[0]
  if (!week) return null
  if (week.close && Number.isFinite(Number(week.close.amount))) return Number(week.close.amount)
  if (Number.isFinite(Number(week.close_cents))) return Number(week.close_cents) / 100
  return null
}

/** Patch the forecast cache from a mutation response. No network. */
export function applyForecastVersion(
  old: ForecastCacheEnvelope | undefined,
  version: unknown,
  auditDelta = 1,
  extras?: { actions?: unknown },
): ForecastCacheEnvelope {
  const prev = old && typeof old === 'object' ? old : {}
  const prevData = prev.data && typeof prev.data === 'object' ? prev.data : {}
  return {
    ...prev,
    data: {
      ...prevData,
      version,
      audit_count: (Number(prevData.audit_count) || 0) + auditDelta,
      ...(extras && extras.actions !== undefined ? { actions: extras.actions } : {}),
    },
    error: prev.error ?? null,
  }
}

export function writeForecastVersion(
  qc: { setQueryData: (key: readonly string[], updater: (old: ForecastCacheEnvelope | undefined) => ForecastCacheEnvelope) => void },
  version: unknown,
  auditDelta = 1,
  extras?: { actions?: unknown },
): void {
  qc.setQueryData(CASH_FORECAST_QUERY_KEY, (old) => applyForecastVersion(old, version, auditDelta, extras))
}
